<template>
	<div class="product-categories">
		<div class="product-categories__title page-subtitle">{{ title }}</div>
		<div class="product-categories__search">
			<InputSearch v-model="searchQuery" actionBtn/>
		</div>
		<div class="product-categories__content">
			<div class="product-categories__block" v-if="filteredCategories?.length">
				<div class="categories-item ci-main" v-for="(checkbox) in filteredCategories" :key="checkbox.id">
					<div class="categories-item__checkbox">
						<div class="categories-item__arrow" v-if="checkbox.children" @click="openList"></div>
						<InputCheckbox
							:label="checkbox.name"
							:id="`${prefix}${checkbox.id}`"
							@change="checkbox.children ? selectAll($event) : fillSelectedProducts($event)"
							:showToggle="showProducts"
						/>
					</div>
					<div class="categories-nested cs-2">
						<div class="categories-item" v-for="(checkbox,index) in checkbox.children" :key="index">
							<div class="categories-item__checkbox">
								<div class="categories-item__arrow" v-if="showProducts" @click="loadProducts(checkbox.id, $event)"></div>
								<InputCheckbox
									:label="checkbox.name"
									:id="showProducts ? null : `${prefix}${checkbox.id}`"
									@change="showProducts ? null : fillSelectedProducts($event)"
									:showToggle="showProducts"
								/>
							</div>
							<div class="categories-nested cs-3" v-if="checkbox.products && showProducts">
								<div class="categories-item" v-for="(checkbox,index) in checkbox.products" :key="index">
									<div class="categories-item__checkbox">
										<InputCheckbox
											:label="checkbox.name"
											:id="checkbox.id"
											:is-test="checkbox.isTest"
											@change="fillSelectedPositions(checkbox, $event)"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="product-categories__empty" v-else>Товарные категории не найдены</div>
			<PageLoader v-if="isLoading" :type="'absolute'"/>
		</div>
	</div>
</template>

<script>
import {defineAsyncComponent} from "vue";
import {mapActions, mapGetters} from "vuex";
import InputSearch from "@/components/base/utils/formElements/InputSearch.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";

export default {
	name: "ProductCategories",
	components: {
		InputSearch,
		InputCheckbox: defineAsyncComponent({
			loader: () => import('@/components/base/utils/formElements/InputCheckbox.vue')
		}),
		PageLoader
	},
	emits: ['update:modelValue'],
	props: {
		title: {
			type: String,
			default: 'Товарные категории'
		},
		prefix: {
			type: String,
			default: ''
		},
		showProducts: {
			type: Boolean,
			default: false
		},
		checkedProductGroups: {
			type: Array,
			default: () => []
		},
		authorized: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			searchQuery: '',
			selectedProducts: new Set(),
			selectedPositions: new Set(),
		}
	},
	async created() {
		await this.requestProductGroups(this.authorized);
		this.chooseProducts()
	},

	methods: {
		openList(e) {
			const nestedList = e.target.closest('.categories-item')
			nestedList.classList.toggle('active')
		},
		selectAll(e) {
			const parentEl = e.target.closest('.categories-item')
			const checked = parentEl.querySelector('.default-checkbox__input').checked
			const checkboxes = parentEl.querySelectorAll('.categories-nested .default-checkbox__input')
			checkboxes.forEach(item => {
				item.checked = checked
				item.dispatchEvent(new Event('change', {bubbles: true}));
			})
		},
		fillSelectedProducts(e) {
			if (e.target.checked) {
				this.selectedProducts.add(e.target.id.replace(/[a-zа-яё]/gi, ''))
			} else {
				this.selectedProducts.delete(e.target.id.replace(/[a-zа-яё]/gi, ''))

				const parentCheckbox = e.target.closest('.categories-item.active')?.querySelector('.categories-item__checkbox input')
				if(parentCheckbox && parentCheckbox.checked) {
					parentCheckbox.checked = false
				}
			}
			this.$emit('update:modelValue', Array.from(this.selectedProducts))
		},

		fillSelectedPositions(checkbox, e) {
			if (e.target.checked) {
				this.selectedPositions.add(checkbox)
			} else {
				this.selectedPositions.delete(checkbox)
			}
			this.$emit('update:modelValue', Array.from(this.selectedPositions))
		},
		chooseProducts() {
			if(this.checkedProductGroups.length) {
				setTimeout(() => {
					this.checkedProductGroups?.forEach(item => {
						const input = document.querySelector(`.default-checkbox__input[id='${this.prefix}${item.id || item}']`)
						if(!input) return
						const parentGroup = input.closest('.ci-main')
						input.checked = true
						setTimeout(() => input.dispatchEvent(new Event('change', {bubbles: true})),200)
						parentGroup.classList.add('ci-main--selected')
					})
				}, 200)
			}
		},
		clearAll() {
			console.log(123)
			const checkboxes = document.querySelectorAll('.product-categories .default-checkbox__input')
			checkboxes.forEach(item => {
				item.checked = false
				item.dispatchEvent(new Event('change', {bubbles: true}));
			})
		},
		loadProducts(id,e) {
			const nestedList = e.target.closest('.categories-item')
			nestedList.classList.toggle('active')
			if(nestedList.classList.contains('active')) {
				this.requestProducts(id)
			}
		},

		...mapActions({
			requestProductGroups: 'products/requestProductGroups',
			requestProducts: 'products/requestProducts',
		})
	},
	computed: {
		filteredCategories() {
			if (this.searchQuery) {
				return this.list.filter(data => {
					if (data.name.toLowerCase().includes(this.searchQuery.toLowerCase())) {
						return true;
					} else if (data.children) {
						const matchingChildren = data.children.filter(child => {
							return child.name.toLowerCase().includes(this.searchQuery.toLowerCase());
						});
						if (matchingChildren.length > 0) {
							return true;
						}
					}
				});
			}
			return this.list
		},
		...mapGetters({
			isLoading: 'isLoading',
			list: 'products/getProductGroups',
		})
	},

}
</script>
